module.exports = __webpack_public_path__ + "static/media/041-woman-11.8d214ecf.svg";